import { useEffect, useState, useCallback, useMemo } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook que retorna a lista de modulos liberados para o usuario logado.
 * Carrega de /api/me/modules e expoe:
 * - modules: array com codigos de modulo liberados
 * - has(code): funcao que verifica se modulo esta liberado
 * - isLoading
 * - planCode, isTrialing
 */
export default function useModules() {
  const { user, token } = useAuth();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!user || !token) {
      setData(null);
      setIsLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API_BASE}/api/me/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [user, token]);

  useEffect(() => {
    reload();
  }, [reload]);

  const modules = useMemo(() => data?.modules || [], [data]);
  const has = useCallback((code) => modules.includes(code), [modules]);

  return {
    modules,
    has,
    isLoading,
    planCode: data?.plan_code || null,
    isTrialing: !!data?.is_trialing,
    reload,
  };
}
